export default __webpack_public_path__ + "static/media/AirAssetIcon.c104fe70.svg";